import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const propTypes = {
  className: PropTypes.string,
  tableTheme: PropTypes.object,
  selectable: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
}

const defaultProps = {
  tag: 'tr',
  tableTheme: {},
}

const TableRow = props => {
  const { className, tableTheme, tag: Tag, selectable, ...attributes } = props

  const classes = classNames(className, tableTheme['table'])

  return <Tag {...attributes} className={classes} />
}

TableRow.propTypes = propTypes
TableRow.defaultProps = defaultProps

export default TableRow



// WEBPACK FOOTER //
// ./ui/Table/Row.js